import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, SubmitInput, Error, Success } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

const CodeRedemptions: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleYesClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      promocodeName: { value: string };
    };

    const promocodeValue = target.promocodeName.value;
    if (!promocodeValue) {
      alert('Invalid input for promocode to check');
      return;
    }

    setIsLoading(true);

    try {
      const count = await callFunction('websiteInternalFunctions/getPromocodeRedemptionCount', {
        promocodeName: promocodeValue
      });
      setSuccess(`Code ${promocodeValue} redeemed ${count} times`);
    } catch (error: any) {
      console.error('Failed to check redemptions:', error);
      setError(error?.message || error?.error || 'Failed to check redemptions');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleYesClick}>
      <Input placeholder="Promo Code to check" name="promocodeName" />
      <SubmitInput type="submit" value={isLoading ? "Checking..." : "Get redemptions"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { CodeRedemptions };
